import { render, staticRenderFns } from "./notification-content.vue?vue&type=template&id=e721cc12"
import script from "./notification-content.vue?vue&type=script&lang=js"
export * from "./notification-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports